// imports react and next
import { useDispatch } from "react-redux";
import Script from "next/script";
import { useEffect } from "react";
//import redux action
import store from "@/redux/store";
import {
  fetchLabelsAndConfigData,
  setLabelsConfigsData,
} from "@/redux/actions/labelsAndConfigActions";

//import graphql queries
import { LABEL_AND_CONFIG_QUERY } from "@/graphql/settingsQuery";
import { PRIVACY_PAGE_QUERY } from "@/graphql/privacyPolicyPageQuery";

import StructuredText from "@/common/UI/StructuredText";

//import components
import MetaTags from "@/common/MetaTags";

// imports utilities
import { fetchPrivacyPolicyPageData } from "@/redux/actions/privacyPolicyPageActions";

export default function PrivacyPolicy(props) {
  const { labelsConfigData, privacyPolicyPageData } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLabelsConfigsData(labelsConfigData));
  }, [dispatch, labelsConfigData]);

  return (
    <>
      <MetaTags
        metaTags={privacyPolicyPageData?._seoMetaTags}
        seoData={privacyPolicyPageData?.seo}
        noFollow={privacyPolicyPageData?.nofollow}
        noIndex={privacyPolicyPageData?.noindex}
      />

      <div className="max-w-[1200px] mx-auto xl:px-0 sm:px-20 px-10 py-40" id="privacy-policy-page">
        <StructuredText data={privacyPolicyPageData.privacyPolicyBlock1.value} />

        <Script src="https://report.cookie-script.com/r/6f39bdda4aec2e715f5c3a9a2df04cdd.js" />
        {/* 
            Intentionally done this way because the above script looks at the first tag that has data-cookiescriptreport selector
            and the appends the html to the adjacent div
        */}
        <div className="privacy-policy-cookie-script-table">
          <div data-cookiescriptreport="report"></div>
        </div>

        <StructuredText data={privacyPolicyPageData.privacyPolicyBlock2.value} />
      </div>
    </>
  );
}

export async function getStaticProps({ preview = false, locale = "en" }) {
  let requestParams = PRIVACY_PAGE_QUERY?.replace(/\lang/g, locale);

  const privacyPolicyResponse = await store.dispatch(
    fetchPrivacyPolicyPageData(requestParams, preview, {}),
  );

  const labelsConfigData = await store.dispatch(
    fetchLabelsAndConfigData(LABEL_AND_CONFIG_QUERY, preview, { lang: locale }),
  );

  return {
    props: {
      preview,
      privacyPolicyPageData: privacyPolicyResponse,
      labelsConfigData: labelsConfigData || {},
    },
  };
}
